import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { ThemeProvider } from 'styled-components';
import CurrencyInput from 'react-currency-input-field'
import { moneyMask } from '../../common/Mask'

class Promocao extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            id:'',
            grupo:'',
            grupos:[],
            grupoDefault:[],
            tipo:'',
            tipos:[],
            tiposDefault:[],
            inicial:'',
            final:'',
            preco:''
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 17 })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/promocao', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState( { items : response.data } );
        })
    }

    add = async(item) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        const grupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        });

        let listarGrupos = [];
        grupos.data.forEach(element => {
            listarGrupos.push({value: element.id, label:element.nome })
        });

        const tipo = []
        tipo.push({value: 1, label: 'Lavar/Passar'})
        tipo.push({value: 2, label: 'Apenas Lavar'})
        tipo.push({value: 3, label: 'Apenas Passar'})

        this.setState({
            isListagem: false, 
            isEdicao:true,
            id:'',
            grupo:'',
            grupos:listarGrupos,
            grupoDefault:[],
            tipo:'',
            tipos:tipo,
            tiposDefault:[],
            inicial: '',
            final: '',
            preco:''           
        })

    }

    edit = async( id ) => {
        
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            const grupos = await api.get('/api/gruposervico', {
                headers: {
                    'x-access-token':token,
                }
            });
       
            await api.get(`/api/promocao/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {

                const grupoDefault = []
                let listarGrupos = [];
                grupos.data.forEach(element => {
                    if(element.id == response.data.grupo_servico) grupoDefault.push({value: element.id, label:element.nome })
                    listarGrupos.push({value: element.id, label:element.nome })
                });
        
                const tipo = []
                tipo.push({value: 1, label: 'Lavar/Passar'})
                tipo.push({value: 2, label: 'Apenas Lavar'})
                tipo.push({value: 3, label: 'Apenas Passar'})
                
                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    id:response.data.id,
                    grupo:response.data.grupo_servico,
                    grupos:listarGrupos,
                    grupoDefault:grupoDefault,
                    tipos:tipo,
                    tiposDefault:response.data.tipo == 1 ?  [{value: 1, label: 'Lavar/Passar'}] : response.data.tipo == 2 ?  [{value: 2, label: 'Apenas Lavar'}] : [{value: 3, label: 'Apenas Passar'}],
                    tipo:response.data.tipo,
                    inicial: response.data.inicial,
                    final:  response.data.final,
                    preco: response.data.preco ? response.data.preco.toFixed(2) : 0                   
                })      
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/promocao', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                grupo:'',
                tipo:'',
                inicial: '',
                final: '',
                preco:'',   
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id,  grupo, tipo, inicial, final, preco } = this.state
        const grupoPermisao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupoPermisao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
               
        try {
            
            const grupoInsertUpdate = {
                grupo: grupo ? grupo : null, 
                tipo: tipo, 
                inicial: inicial, 
                final: final, 
                preco: final
            }
            
            if ( id ) {
                if(  empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
               
                await api.put(`/api/promocao/${id}`,grupoInsertUpdate, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/promocao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            grupo:'',
                            grupos:[],
                            grupoDefault:[],
                            tipo:'',
                            tipos:[],
                            tiposDefault:[],
                            inicial: '',
                            final: '',
                            preco:'',                              
                            items : response.data
                
                        });
                       
                    })
                })
            } else {
                
                if(  empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 

                await api.post('/api/promocao', grupoInsertUpdate, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    
                    await api.get('/api/promocao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            grupo:'',
                            grupos:[],
                            grupoDefault:[],
                            tipo:'',
                            tipos:[],
                            tiposDefault:[],
                            inicial: '',
                            final: '',
                            preco:'',                  
                            items : response.data
                
                        });
                    })
                    
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 17  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                await api.delete(`/api/promocao/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/promocao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }    

    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/grupo', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                grupo:'',
                tipo:'',
                inicial: '',
                final: '',
                preco:'',                 
                items : response.data    
            })
        })
    }
    
    render() {

        const columns = [
            {
              name: 'Grupo',
              selector: 'grupo',
              sortable: true,
            }, 
            {
                name: 'Tipo',
                selector: 'tipo',
                sortable: true,
                cell: row => row.tipo == 1 ? 'Lavar e Passar' : row.tipo == 2 ? 'Lavar' : 'Passar' 
            }, 
            {
                name: 'Inicial',
                selector: 'inicial',
                sortable: true,
            },
            {
                name: 'Final',
                selector: 'final',
                sortable: true,
            }, 
            {
                name: 'Preço',
                selector: 'preco',
                sortable: true,
                cell: row => row.preco.toFixed(2)
            }, 
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO PROMOÇÃO</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                />
                                            <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                
                                            </div>
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div className="form-group">
                                                        <label>ID</label>
                                                        <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Grupo</label>
                                                        <Select
                                                            id="grupo"
                                                            placeholder="Selecione" 
                                                            isSearchable="true"
                                                            isOptionSelected
                                                            value={this.state.grupoDefault}
                                                            options={ this.state.grupos } 
                                                            onChange={ e => this.setState({grupo: e.value, grupoDefault:[{label: e.label, value: e.value }] })}
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Tipo</label>
                                                        <Select
                                                            id="tipo"
                                                            placeholder="Selecione" 
                                                            isSearchable="true"
                                                            isOptionSelected
                                                            value={this.state.tipoDefault}
                                                            options={ this.state.tipos } 
                                                            onChange={ e => this.setState({tipo: e.value, tipoDefault:[{label: e.label, value: e.value }] })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Inicial</label>
                                                        <CurrencyInput
                                                            id="inicial"
                                                            name="input-inicial"
                                                            className="form-control" 
                                                            placeholder="Informe quanitdade inicial do serviço"
                                                            defaultValue={ 1.00 }
                                                            decimalsLimit={2}
                                                            value={this.state.inicial ? this.state.inicial : 0.00 }
                                                            onValueChange={(value, name) => this.setState({ inicial: value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Final</label>
                                                        <CurrencyInput
                                                            id="final"
                                                            name="input-final"
                                                            className="form-control" 
                                                            placeholder="Informe quanitdade final do serviço"
                                                            defaultValue={ 1.00 }
                                                            decimalsLimit={2}
                                                            value={this.state.final ? this.state.final : 0.00 }
                                                            onValueChange={(value, name) => this.setState({ final: value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Preço</label>
                                                        <input
                                                            type="text"
                                                            id="preco"
                                                            name="pago"
                                                            class="form-control"
                                                            placeholder="Informe o valor"
                                                            value={this.state.preco}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    preco: moneyMask(e.target.value),
                                                                })
                                                            }                                                        
                                                        />
                                                        
                                                    </div>                                                   
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Promocao;